(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'AllInclusivePropertySheetBuildLivePricing',
	};

	$(document).ready(function documentReady() {
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('#allinclusivepropertysheetbuildlivepricing-num_children').change(function addPaxFields()
		{
			var $fields = $form.find('.child-age');

			$fields
				.addClass('hidden')
				.find('select')
				.prop('disabled', true);

			if (this.value > 0) {
				$fields.slice(0, this.value)
					.removeClass('hidden')
					.find('select')
					.prop('disabled', false);
			}
		});
	};
}(jQuery, window.Adzuki || {}));
